
export enum SiteElementType {
  // Don't change the already set values (ordering, values and available enumerations) without thorough
  // testing, as this will otherwise break the data fetching completely
  FOOTER,
  DID_YOU_MEAN_CONFIG,
  UNDEFINED,
}

export class SiteElement {

  public Id: number;
  public Language: string;
  public Type: SiteElementType;
  public Content: string;

  constructor(opt?: Partial<SiteElement>) {
    Object.assign(this, opt);
  }
}
